<div *ngIf="isMobile">
  <app-customer-info-mobile  [customerObject]="customer"></app-customer-info-mobile>
</div>
<div *ngIf="!isMobile">
  <app-customer-info-desktop  [customerObject]="customer"></app-customer-info-desktop>
</div>
